import script from "./ProjectRadarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectRadarChart.vue?vue&type=script&setup=true&lang=js"

import "./ProjectRadarChart.vue?vue&type=style&index=0&id=7c23a999&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c23a999"]])

export default __exports__